<template>
  <section>
    <div class="admin-row"><slot></slot></div>
  </section>
</template>
